export const OPEN_WORKFLOW_MENU_TRANSACTION = 'WORKFLOW.OPEN_WORKFLOW_MENU_TRANSACTION';
export const OPEN_APPROVE_DETAIL_TRANSACTION = 'WORKFLOW.OPEN_APPROVE_DETAIL_TRANSACTION';
export const CONTINUE_PROCESS_TRANSACTION = 'WORKFLOW.CONTINUE_PROCESS_TRANSACTION';
export const SET_DEPLOY_AGENTS_ACTION = 'WORKFLOW.SET_DEPLOY_AGENTS_ACTION';
export const DEPLOY_AGENT_READY = 'WORKFLOW.DEPLOY_AGENT_READY';
export const DRAFT_ITEM_DELETED = 'WORKFLOW.DRAFT_ITEM_DELETED';
export const START_MESSAGE = 'WORKFLOW.START_MESSAGE';
export const INFORMATION_MESSAGE = 'WORKFLOW.INFORMATION_MESSAGE';
export const APPROVAL_MESSAGE = 'WORKFLOW.APPROVAL_MESSAGE';
export const FINISH_MESSAGE = 'WORKFLOW.FINISH_MESSAGE';
export const APPROVAL_MESSAGE_CLICK = 'WORKFLOW.APPROVAL_MESSAGE_CLICK';
export const STOP_MESSAGE = 'WORKFLOW.STOP_MESSAGE';
export const WORKFLOW_LIST_LOAD_MORE = 'WORKFLOW.WORKFLOW_LIST_LOAD_MORE';
export const WORKFLOW_ON_SEARCH_ACTIONS_TRANSACTION =
	'WORKFLOW.WORKFLOW_ON_SEARCH_ACTIONS_TRANSACTION';
export const WORKFLOW_LIST_UPDATE_COUNT = 'WORKFLOW.WORKFLOW_LIST_UPDATE_COUNT';
export const PANEL_CLOSE_BY_PROCESSID_ACTION = 'WORKFLOW.PANEL_CLOSE_BY_PROCESSID_ACTION';
export const SET_PENDING_FAST_APPROVE_DOCUMENT_COUNT_ACTION =
	'WORKFLOW.SET_PENDING_FAST_APPROVE_DOCUMENT_COUNT_ACTION';
